import {
  IonButton,
  IonContent,
  IonGrid,
  IonLabel,
  IonPage,
  IonPopover,
  IonSegment,
} from "@ionic/react";
import React from "react";
import FileUpload from "../../components/FileUpload";
import HeaderToolbar from "../../components/HeaderToolbar";
import Loading from "../../components/Loading";
import DisplayMessage from "../../components/Membership/DisplayMessage";
import JoinIIA from "../../components/Membership/JoinIIA";
import MembershipCard from "../../components/Membership/MembershipCard";
import PaymentForm from "../Membership/PaymentForm";
import {
  ImageExtensions,
  ProfilePhotoDirectory,
} from "../../constants/FileUploadConstants";
import {
  ApprovedMembershipDisplayMessage,
  MembershipProfileStatus,
  RejectedMembershipDisplayMessage,
  SubmitMembershipDisplayMessage,
} from "../../constants/MembershipConstants";
import {
  CreateUpadateMembershipPage,
  MembershipBenefitPage,
  MembershipPage,
} from "../../constants/MenuConstants";
import approvedMembership from "../../images/approvedMembership.svg";
import rejectedMembership from "../../images/rejectedMembership.svg";
import submittedMembership from "../../images/submittedMembership.svg";
import { LoginMetadata } from "../../models/LoginMetadata";
import { ActiveMembershipModel } from "../../models/Membership/ActiveMembershipModel";
import { MembershipProfileModel } from "../../models/Membership/MembershipProfileModel";
import { Call2 } from "../../services/BaseService";
import { MembershipService } from "../../services/MembershipService";
import "../../styles/Membership.css";
import { Browser } from "@capacitor/browser";
import MembershipProfile from "../../components/Membership/MembershipProfile";
import { getDefaultSettings } from "http2";
interface MembershipStates {
  membershipModel: ActiveMembershipModel;
  membershipProfile: MembershipProfileModel;
  membershipStatus: number;
  showProgress: boolean;
  profileImagePath: string;
  showPopover: boolean;
  showPayment: boolean;
  showUpdate: boolean;
  gst: string;
  renewalDate:string;
  originalFormate:string;
}

interface MembershipProps {
  loginMetadata: LoginMetadata;
  setLoginStateFunction: (loginMetadata: LoginMetadata | null) => void;
  changePage: (value: string) => void;
}

class Membership extends React.Component<MembershipProps, MembershipStates> {
  constructor(props: MembershipProps) {
    super(props);
    this.state = {
      membershipModel: new ActiveMembershipModel(),
      membershipProfile: new MembershipProfileModel(
        this.props.loginMetadata.tokenString,
        0,
        -1
      ),
      membershipStatus: this.props.loginMetadata.membershipStatus,
      showProgress: true,
      profileImagePath: "",
      showPopover: false,
      showPayment: false,
      showUpdate: false,
      gst: "",
      renewalDate:"",
      originalFormate:""
    };
  }

  
async getRenwabledate(loginMetadata){
  const data = {
    loginMetadata:loginMetadata,
  }
  const response = await fetch('https://iiaonline.in/newapi_iia/getMembershipInfo.php',{
    method:'POST',
    body:JSON.stringify(data)
  })
  const result = await response.json();
  return result;
}


componentDidMount() {
  this.getData(true);
}

protected getData(forceRefresh: boolean) {
  this.setState({ showProgress: true });
  let getActiverMembershipPromise = MembershipService.getActiveMembership(
    this.props.loginMetadata,
    forceRefresh
  );
  let getMembershipProfilePromise = MembershipService.getMembershipProfile(
    this.props.loginMetadata,
    forceRefresh,
    {}
  );
  let rennewaledate =  this.getRenwabledate(this.props.loginMetadata);
  Promise.all([getActiverMembershipPromise, getMembershipProfilePromise,rennewaledate])
    .then((result: any[]) => {
      console.log(result[0]);
      this.setState({
        membershipModel: result[0],
        membershipProfile: result[1][0],
        membershipStatus: result[1][0].profileStatus,
        showProgress: false,
        showPayment: false,
        profileImagePath: result[1][0].profileImagePath,
        renewalDate:result[2].expirydate,
        originalFormate:result[2].actualdate
      });
      this.props.loginMetadata.membershipStatus = result[1][0].profileStatus;
      this.props.setLoginStateFunction(this.props.loginMetadata);
    })
    .catch(() => {});
}

  updateProfile(event: any) {}
  //

  

  renewMembership(event: any) {}
  public setMembershipStatusFunction(value: number) {
    this.setState({ membershipStatus: value });
  }
  render() {
    if (this.state.showPayment) {
      return (
        <PaymentForm
          loginMetadata={this.props.loginMetadata}
          expiryYear={this.state.originalFormate}
          resetMembershipData={(forceRefresh: boolean) => {
            this.getData(forceRefresh);
          }}
          changePage={() => {
            this.setState({ showPayment: false });
          }}
        />
      );
    }
    if (this.state.showUpdate) {
      return (
        <IonPage>
          <HeaderToolbar
            showBackButton={true}
            showRefreshButton={false}
            refreshPage={() => {}}
            previousPage={() => {
              this.setState({ showUpdate: false });
            }}
          />
          <IonContent>
            <MembershipProfile
              membershipProfile={this.state.membershipProfile}
              disabled={false}
              gstCheck={false}
              page={MembershipPage.Page}
              loginMetadata={this.props.loginMetadata}
              setMembershipStatusFunction={(value: number) => this.reset(value)}
              setLoginStateFunction={(loginMetadata: LoginMetadata | null) =>
                this.props.setLoginStateFunction(loginMetadata)
              }
              changePage={(value: string) => this.props.changePage(value)}
            />
          </IonContent>
        </IonPage>
      );
    }
    if (this.state.showProgress) {
      return (
        <IonPage>
          <HeaderToolbar
            refreshPage={() => {}}
            previousPage={() => {}}
            showBackButton={false}
            showRefreshButton={false}
          />
          <Loading />
        </IonPage>
      );
    } else if (
      this.state.membershipStatus ==
      MembershipProfileStatus.SubmittedMembershipProfile
    ) {
      return (
        <IonPage>
          <HeaderToolbar
            refreshPage={() => this.getData(true)}
            previousPage={() => {}}
            showBackButton={false}
            showRefreshButton={true}
          />
          <IonContent>
            <DisplayMessage
              logoPath={submittedMembership}
              message={SubmitMembershipDisplayMessage}
            />
          </IonContent>
        </IonPage>
      );
    } else if (
      this.state.membershipStatus ==
      MembershipProfileStatus.RejectedMembershipProfile
    ) {
      return (
        <IonPage>
          <HeaderToolbar
            refreshPage={() => this.getData(true)}
            previousPage={() => {}}
            showBackButton={false}
            showRefreshButton={true}
          />
          <IonContent>
            <DisplayMessage
              logoPath={rejectedMembership}
              message={RejectedMembershipDisplayMessage}
            />
            <IonButton
              class="reapplyButton limitContent"
              onClick={() => this.setState({ showUpdate: true })}
            >
              Re-apply
            </IonButton>
          </IonContent>
        </IonPage>
      );
    } else if (
      this.state.membershipStatus ==
      MembershipProfileStatus.ApprovedMembershipProfile
    ) {
      const now  = new Date()
      return (
        <IonPage>
          <HeaderToolbar
            refreshPage={() => this.getData(true)}
            previousPage={() => {}}
            showBackButton={false}
            showRefreshButton={true}
          />
          <IonContent>
            <DisplayMessage
              logoPath={approvedMembership}
              message={ApprovedMembershipDisplayMessage}
            />
            <IonSegment mode ="md">
                <IonButton
                  class="basicButton viewBenefitsButton"
                  onClick={() => this.pay()}
                >
                  pay {now.getMonth() < 3 ? (now.getFullYear()-1)+ "-" + now.getFullYear():(now.getFullYear())+ "-" + (now.getFullYear()+1)}
                </IonButton>
              </IonSegment>
          </IonContent>
        </IonPage>
      );
    } else if (
      this.state.membershipStatus == MembershipProfileStatus.NewMembership
    ) {
      return (
        <JoinIIA
          membershipProfile={this.state.membershipProfile}
          loginMetadata={this.props.loginMetadata}
          setMembershipStatusFunction={(value: number) =>
            this.setMembershipStatusFunction(value)
          }
          setLoginStateFunction={(loginMetadata: LoginMetadata | null) =>
            this.props.setLoginStateFunction(loginMetadata)
          }
          changePage={(value: string) => this.props.changePage(value)}
        />
      );
    } else if (
      this.state.membershipStatus >= MembershipProfileStatus.ActiveMembership &&
      this.state.membershipStatus <= MembershipProfileStatus.ExpiredMembership
    ) {
      return (
        <IonPage>
          <HeaderToolbar
            refreshPage={() => this.getData(true)}
            previousPage={() => {}}
            showBackButton={false}   
            showRefreshButton={true}
          />
          <IonContent>
            <IonGrid className="limitContent">
              <IonSegment mode ="md">
                <MembershipCard
                  membershipModel={this.state.membershipModel}
                  membershipProfile={this.state.membershipProfile}
                  renewalDate={this.state.renewalDate}
                />
              </IonSegment>
              <IonSegment mode ="md">
                <IonButton
                  class="basicButton viewBenefitsButton"
                  routerLink={"/" + MembershipBenefitPage.Page}
                  onClick={() =>
                    this.props.changePage(MembershipBenefitPage.Page)
                  }
                >
                  View Membership Benefits
                </IonButton>
              </IonSegment>
              {this.state.membershipProfile.profileImagePath == "" ? (
                <IonSegment mode ="md" class="profilePictureImageUploadButton">
                  <FileUpload
                    supportedExtensions={ImageExtensions}
                    loginMetadata={this.props.loginMetadata}
                    onFileUploaded={(path: string) =>
                      this.onProfileImagePathChange(path)
                    }
                    buttonTitle={"Image"}
                    fileDirectory={ProfilePhotoDirectory}
                    filePath={this.state.profileImagePath}
                    buttonLabel="Profile Photo"
                    disabled={false}
                    id="profileImagePhoto"
                  />
                  <IonPopover
                    isOpen={this.state.showPopover}
                    backdropDismiss={false}
                    cssClass="uploadProfilePicturePopover"
                  >
                    <IonSegment mode ="md" class="previewText">Preview</IonSegment>
                    <IonSegment mode ="md">
                      <img
                        src={this.state.profileImagePath}
                        className="profilePictureUploadPreview"
                      ></img>
                    </IonSegment>
                    <IonSegment mode ="md" class="uploadProfilePictureButtons">
                      <IonButton
                        class="profilePictureUploadButton"
                        onClick={() => {
                          this.upload();
                        }}
                      >
                        <IonLabel>Submit</IonLabel>
                      </IonButton>
                      <IonButton
                        class="profilePictureUploadButton"
                        onClick={() => {
                          this.cancelUpload();
                        }}
                      >
                        <IonLabel>Cancel</IonLabel>
                      </IonButton>
                    </IonSegment>
                  </IonPopover>
                </IonSegment>
              ) : null}

              {this.state.membershipStatus >=
                MembershipProfileStatus.ActiveMembership && (new Date().getMonth() > 2 && new Date().getFullYear() >= parseInt(
                        this.state.renewalDate.slice(6, 10)
                      ) || new Date().getMonth() < 3 && new Date().getFullYear() > parseInt(
                        this.state.renewalDate.slice(6, 10)
                ))
              // (this.state.membershipStatus ==
              //   MembershipProfileStatus.ActiveMembership &&
              //   new Date().getMonth() < 3 &&
              //   new Date().getFullYear() ==
              //     parseInt(
              //       this.state.renewalDate.slice(6, 10)
              //     )) 
              ? (
                <IonSegment mode ="md">
                  <IonButton
                    class="basicButton viewBenefitsButton"
                    onClick={() => this.pay()}
                  >
                    pay{" "}
                    {this.state.renewalDate.slice(
                      6,
                      10
                    )}
                    -
                    {parseInt(
                      this.state.renewalDate.slice(
                        6,
                        10
                      )
                    ) + 1}
                  </IonButton>
                </IonSegment>
              ) : null}
            </IonGrid>
          </IonContent>
        </IonPage>
      );
    } else {
      return (
        <IonPage>
          <HeaderToolbar
            refreshPage={() => this.getData(true)}
            previousPage={() => {}}
            showBackButton={false}
            showRefreshButton={true}
          />
          <IonContent>
            <DisplayMessage
              logoPath={rejectedMembership}
              message="Please Login Again"
            />
          </IonContent>
        </IonPage>
      );
    }
  }
  onProfileImagePathChange(path: string): void {
    this.setState({ profileImagePath: path, showPopover: true });
  }
  upload() {
    this.setState({ showProgress: true });
    MembershipService.updateMemberProfilePhoto(
      this.props.loginMetadata,
      this.state.profileImagePath
    )
      .then((res: any) => {
        this.state.membershipProfile.profileImagePath =
          this.state.profileImagePath;
        this.getData(true);
        this.setState({ showProgress: false, showPopover: false });
      })
      .catch((error: any) => {
        this.setState({ profileImagePath: "", showPopover: false });
      });
  }
  cancelUpload() {
    this.setState({ profileImagePath: "", showPopover: false });
  }
  public reset(value: number) {
    this.setState({
      showUpdate: false,
      membershipProfile: new MembershipProfileModel(
        this.props.loginMetadata.tokenString,
        value,
        -1
      ),
      membershipStatus: value,
    });
    this.getData(true);
  }
  pay() {
    this.setState({ showPayment: true });
  }
}

export default Membership;
